import { Component, inject } from '@angular/core';
import { SilvicultureActivityParameterService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SilvicultureActivityParameterCreateDto,
  SilvicultureActivityParameterDto,
  SilvicultureActivityParameterExcelDownloadDto,
  SilvicultureActivityParameterUpdateDto,
} from '../proxy/controlling/dtos/silviculture-activity-parameter';
import { SILVICULTUREACTIVITYPARAMETER_CONFIG, SILVICULTUREACTIVITYPARAMETER_FIELDS } from './silviculture-activity-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-silviculture-activity-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SilvicultureActivityParameterService, ConfirmationService],
  templateUrl: './silviculture-activity-parameter.html',
  styleUrl: './silviculture-activity-parameter.scss',
})
export class SilvicultureActivityParameter extends BaseHierarchicalCrudComponent<
  SilvicultureActivityParameterDto,
  SilvicultureActivityParameterCreateDto,
  SilvicultureActivityParameterUpdateDto,
  SilvicultureActivityParameterExcelDownloadDto
> {
  service = inject(SilvicultureActivityParameterService);
  config = SILVICULTUREACTIVITYPARAMETER_CONFIG;
  fields = SILVICULTUREACTIVITYPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: SilvicultureActivityParameterDto): SilvicultureActivityParameterUpdateDto {
    return {
      applyDose: data.applyDose,
      doses: data.doses,
      operativeWidth: data.operativeWidth,
      isRegrowth: data.isRegrowth,
      applyNearbyPopulation: data.applyNearbyPopulation,
      applyExecutionWithRotationGreatherThanOne: data.applyExecutionWithRotationGreatherThanOne,
      isManual: data.isManual,
      activityProcessParametrizationId: data.activityProcessParametrizationId,
      levelId: data.levelId,
      activityMomentId: data.activityMomentId,
      activityPlaceId: data.activityPlaceId,
      activityReasonId: data.activityReasonId,
      wbsId: data.wbsId,
      activityToolId: data.activityToolId,
      spacingTypeId: data.spacingTypeId,
      plantationTypeId: data.plantationTypeId,
      fieldSituationId: data.fieldSituationId,
      workTypeId: data.workTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SilvicultureActivityParameter';
  }
}
